import { wrapConsole } from './capture-console';
import { wrapError } from './capture-error';
import { Identity } from './types';

export function wrapAll(state: Identity) {
  wrapError(state);
  wrapConsole(state);
}
